import React, { Component } from 'react'; // React และ Component
import { Link } from 'react-router-dom'; // สำหรับลิงก์ใน React Router
import withRouter from '../withRouter'; // HOC สำหรับใช้งานกับ Router

import axios from 'axios'; // สำหรับเรียก API

// นำเข้าคอมโพเนนต์ UI จาก react-bootstrap
import {
    Breadcrumb,
    Row,
    Col,
    Card,
    Image
} from 'react-bootstrap';

// ไลบรารีสำหรับสร้างไฟล์ .docx จาก HTML
import {
    Document, Packer, Paragraph, TextRun, ImageRun,
    AlignmentType, convertMillimetersToTwip,
    Table, TableRow, TableCell, WidthType, BorderStyle, ShadingType
} from "docx";

// ฟอนต์ภาษาไทย Sarabun
import TH_Sarabun_PSK from '../../fonts/TH_Sarabun_PSK/THSarabun.ttf';

// คอมโพเนนต์ UI จาก rsuite
import {
    Tabs,
    ButtonToolbar,
    IconButton,
    Checkbox,
    Whisper,
    Tooltip,
    Loader
} from 'rsuite';

class DetailPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            header: null,
            content: null,
        };
    }

    async componentDidMount() {
        try {
            const token = localStorage.getItem('token');

            if (!token) {
                this.props.navigate('/admin/login');
                return;
            }

            const isTokenExpired = () => {
                try {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    const expiry = payload.exp * 1000;
                    return Date.now() > expiry;
                } catch {
                    return true;
                }
            };

            if (isTokenExpired()) {
                this.props.navigate('/admin/login');
                return;
            }

            const authHeader = { headers: { 'Authorization': `Bearer ${token}` } };

            // ✅ set authHeader ใน state ก่อนเรียก onRenderContent
            await this.promisedSetState({ authHeader });

            const responseApplicant = await axios.get(
                `${process.env.REACT_APP_API}/application/${this.props.params.id}`,
                authHeader
            );
            const data = responseApplicant.data[0];

            await this.promisedSetState({ data });

            await this.onRenderHeader({ mode: 'read' });
            await this.onRenderContent({ mode: 'read', report: 'short', data });

        } catch (error) {
            console.error('Error loading data:', error);
        }
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRenderHeader = async ({ mode }) => {
        if (mode === 'read') {
            const responseApplicant = await axios.get(`${process.env.REACT_APP_API}/application/${this.props.params.id}`, this.state.authHeader);
            const data = responseApplicant.data[0]

            await this.promisedSetState({
                header: <><Row className='mt-3'>
                    <Col>
                        <Breadcrumb size='lg' >
                            <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                            <Breadcrumb.Item>ข้อมูลผู้สมัคร</Breadcrumb.Item>
                            <Breadcrumb.Item active>{`${data.first_name} ${data.last_name}`}</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                    <Row className='mb-3'>
                        <Col md={4}>
                        </Col>

                        <Col md={4} className="d-flex justify-content-center">
                            <Tabs defaultActiveKey="short" appearance="pills" onSelect={e => this.onRenderContent({ mode: 'read', report: e, data })}>
                                <Tabs.Tab eventKey="short" title="ประวัติย่อ" />
                                <Tabs.Tab eventKey="long" title="ประวัติแบบละเอียด" />
                            </Tabs>
                        </Col>

                        <Col md={4} className="d-flex justify-content-end">
                            <ButtonToolbar>
                                <Whisper
                                    followCursor
                                    speaker={<Tooltip>Print</Tooltip>}
                                >
                                    <IconButton
                                        icon={<i className="bi bi-printer"></i>}
                                        style={{ backgroundColor: '#adadad', color: 'white' }}
                                        onClick={this.handlePrint}
                                    />
                                </Whisper>
                                <Whisper
                                    followCursor
                                    speaker={<Tooltip>Document</Tooltip>}
                                >
                                    <IconButton
                                        color="blue"
                                        appearance="primary"
                                        icon={<i className="bi bi-file-earmark-word"></i>}
                                        onClick={this.handleExportToDocx}
                                    />
                                </Whisper>
                            </ButtonToolbar>
                        </Col>
                    </Row></>
            })
        }
    }

    formatDateOfBirth(dateOfBirth) {
        const date = new Date(dateOfBirth);

        // Thai locale options for formatting
        const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        };

        // Format the date using Thai locale
        const formattedDate = new Intl.DateTimeFormat('th-TH', options).format(date);

        // Convert the year to Buddhist Era (BE), which is 543 years ahead of the Gregorian calendar
        const buddhistYear = date.getFullYear() + 543;

        // Replace the Gregorian year with the Buddhist Era year in the formatted date
        const finalDate = formattedDate.replace(date.getFullYear(), buddhistYear);

        return finalDate;
    }

    calculateAge = (date_of_birth) => {
        const birthDate = new Date(date_of_birth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();

        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    formatBaht(income) {
        // Convert the number to a formatted string with commas and two decimal places
        return income.toLocaleString('th-TH', {
            minimumFractionDigits: 2,  // Ensures two decimal places
            maximumFractionDigits: 2   // Limits to two decimal places
        });
    }

    onRenderContent = async ({ mode, report, data }) => {
        await this.promisedSetState({ currentReport: report });

        if (mode === 'read' && report === 'short') {

            await this.promisedSetState({ loading: true })

            const statusMap = {
                'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ': data.parent_status_1,
                'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ': data.parent_status_2,
                'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ': data.parent_status_3,
                'อื่นๆ โปรดระบุ': data.parent_status_4
            };

            const extraText = statusMap[data.parent_status] || '';

            const parentStatusText = extraText
                ? `${data.parent_status} ${extraText}`
                : data.parent_status;

            await this.promisedSetState({
                content: <div>
                    <Row>
                        <Col>
                            <Card
                                id="printable"
                                border="light"
                                className="shadow-sm"
                                style={{
                                    paddingLeft: "1.5em",
                                    paddingTop: "1em",
                                    paddingRight: "1em",
                                    paddingBottom: "1em",
                                    fontSize: '16pt',
                                    lineHeight: '1.2'
                                }}
                            >
                                {/* Row for "ลำดับที่......" */}
                                <div style={{ marginTop: '1.5em', textAlign: "center" }}>
                                    <Image
                                        src={`${process.env.REACT_APP_UPLOAD}/${data.path}`}
                                        rounded
                                        style={{ width: "2.5cm", height: "3.5cm" }}
                                    />
                                </div>

                                <div style={{ marginTop: '1em' }}>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}><b>สิทธิ์ในการสมัคร</b></span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights4}
                                            readOnly
                                        >
                                            บุตรพนักงาน
                                        </Checkbox>
                                    </span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights1}
                                            readOnly
                                        >
                                            พื้นที่โครงการพัฒนาดอยตุงฯ
                                        </Checkbox>
                                    </span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights2}
                                            readOnly
                                        >
                                            พื้นที่ขยายผลในมูลนิธิฯ
                                        </Checkbox>
                                    </span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights3}
                                            readOnly
                                        >
                                            โรงเรียนบ้านห้วยไร่สามัคคี
                                        </Checkbox>
                                    </span>
                                </div>

                                <div><span><b><u>ข้อมูลทั่วไป</u></b></span></div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, max-content 1fr)', gap: '4px' }}>

                                    {/* Row 1 */}
                                    <span>ชื่อ-สกุล:</span>
                                    <span>{`${data.first_name} ${data.last_name}`}</span>
                                    <span>ชื่อเล่น:</span>
                                    <span>{data.nickname}</span>
                                    <span></span><span></span>

                                    {/* Row 2 */}
                                    <span>วัน/เดือน/ปี เกิด:</span>
                                    <span>{this.formatDateOfBirth(data.date_of_birth)}</span>
                                    <span>อายุ:</span>
                                    <span>{this.calculateAge(data.date_of_birth)} ปี</span>
                                    <span>เบอร์โทร:</span>
                                    <span>{data.phone}</span>

                                    {/* Row 3: ที่อยู่ */}
                                    <span>ที่อยู่:</span>
                                    <span style={{ gridColumn: 'span 5' }}>
                                        {data.reg_province_id === 1 ? (
                                            <>
                                                บ้านเลขที่ {data.reg_house_number} หมู่ที่ {data.reg_village_no} หมู่บ้าน
                                                {data.reg_village === "other" ? data.reg_village_name : data.reg_village}{" "}
                                                {data.reg_tambon} {data.reg_amphur} {data.reg_province}
                                            </>
                                        ) : (
                                            <>
                                                บ้านเลขที่ {data.reg_house_number} หมู่ที่ {data.reg_village_no} หมู่บ้าน
                                                {data.reg_village === "other" ? data.reg_village_name : data.reg_village} ต.
                                                {data.reg_tambon} อ.{data.reg_amphur} จ.{data.reg_province}
                                            </>
                                        )}
                                    </span>

                                    {/* Row 4 */}
                                    <span>เลขบัตรประชาชน:</span>
                                    <span>{data.id_card_number}</span>
                                    <span>เลข คพต.พ ของผู้สมัคร:</span>
                                    <span>{(!data.applicant_proj_no || data.applicant_proj_no === 'คพต.พ _-__-____') ? '-' : data.applicant_proj_no}</span>
                                    <span></span><span></span>

                                    {/* Row 5 */}
                                    <span>การศึกษาเดิม:</span>
                                    <span>{data.edu_level}</span>
                                    <span>โรงเรียน:</span>
                                    <span style={{ gridColumn: 'span 3' }}>{data.curr_institution}</span>

                                    {/* Row 6 */}
                                    <span></span>
                                    <span></span>
                                    <span>สายการเรียน:</span>
                                    <span style={{ gridColumn: 'span 3' }}>{data.curr_field}</span>

                                    {/* Row 7 */}
                                    <span>ผลการเรียน:</span>
                                    <span style={{ gridColumn: 'span 5' }}>{data.grades}</span>

                                    {/* ===== ข้อมูลการศึกษาต่อ ===== */}
                                    <span style={{ gridColumn: 'span 6', marginTop: '1em' }}><b><u>ข้อมูลการศึกษาต่อ</u></b></span>

                                    <span>สถานศึกษา:</span>
                                    <span style={{ gridColumn: 'span 5' }}>{data.next_institution}</span>

                                    <span>สาขาที่ศึกษาต่อ:</span>
                                    <span style={{ gridColumn: 'span 5' }}>{data.next_field}</span>

                                </div>

                                <div style={{ marginTop: '1em' }}><span><b><u>ข้อมูลการพิจารณาทุน</u></b></span></div>

                                <div><span><b>ส่วนที่ 1 ครอบครัวและรายได้</b></span></div>
                                {/* ครอบครัว */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, max-content 1fr)', gap: '4px' }}>

                                    {/* สภาพครอบครัว */}
                                    <span>สภาพครอบครัว:</span>
                                    <span>{parentStatusText}</span>
                                    <span></span><span></span><span></span><span></span>

                                    {/* บิดา */}
                                    <span style={{ paddingLeft: '2em' }}>ชื่อบิดา:</span>
                                    <span>{data.father_full_name}</span>
                                    <span>อาชีพ:</span>
                                    <span>{data.father_occupation}</span>
                                    <span>รหัสพนักงาน</span>
                                    <span>{data.rights4 ? (data.rights_father_no || '-') : '-'}</span>

                                    <span style={{ paddingLeft: '2em' }}></span>
                                    <span></span>
                                    <span>ส่วนงาน/แผนก:</span>
                                    <span style={{ gridColumn: 'span 3' }}>{data.rights4 ? (data.rights_father_job_title || '-') : '-'}</span>

                                    {/* มารดา */}
                                    <span style={{ paddingLeft: '2em' }}>ชื่อมารดา:</span>
                                    <span>{data.mother_full_name}</span>
                                    <span>อาชีพ:</span>
                                    <span>{data.mother_occupation}</span>
                                    <span>รหัสพนักงาน</span>
                                    <span>{data.rights4 ? (data.rights_mother_no || '-') : '-'}</span>

                                    <span style={{ paddingLeft: '2em' }}></span>
                                    <span></span>
                                    <span>ส่วนงาน/แผนก:</span>
                                    <span style={{ gridColumn: 'span 3' }}>{data.rights4 ? (data.rights_mother_job_title || '-') : '-'}</span>

                                    {/* พี่น้อง */}
                                    <span style={{ paddingLeft: '2em' }}>จำนวนพี่น้อง:</span>
                                    <span>{data.total_siblings} คน</span>
                                    <span></span><span></span><span></span><span></span>

                                    {/* รายได้ */}
                                    <span>จำนวนรายได้รวม:</span>
                                    <span>{this.formatBaht(data.family_income_per_year)} บาท ต่อปี</span>
                                    <span></span><span></span><span></span><span></span>

                                    {/* ที่อยู่อาศัยในพื้นที่ */}
                                    <span>ที่อยู่อาศัยในพื้นที่:</span>
                                    <span>{data.family_residence_rai} ไร่ {data.family_residence_ngan} งาน {data.family_residence_wah} ตารางวา</span>
                                    <span></span><span></span><span></span><span></span>

                                    {/* ที่ทำกินในพื้นที่ */}
                                    <span>ที่ทำกินในพื้นที่:</span>
                                    <span>{data.family_work_rai} ไร่ {data.family_work_ngan} งาน {data.family_work_wah} ตารางวา</span>
                                    <span></span><span></span><span></span><span></span>

                                    {/* ที่อยู่อาศัยนอกพื้นที่ */}
                                    <span>ที่อยู่อาศัยนอกพื้นที่:</span>
                                    <span>- ไร่ - งาน - ตารางวา</span>
                                    <span></span><span></span><span></span><span></span>

                                    {/* ที่ทำกินนอกพื้นที่ */}
                                    <span>ที่ทำกินนอกพื้นที่:</span>
                                    <span>- ไร่ - งาน - ตารางวา</span>
                                    <span></span><span></span><span></span><span></span>

                                </div>

                                {/* ส่วนที่ 2 */}
                                <div><span><b>ส่วนที่ 2 กิจกรรมที่เข้าร่วมระหว่างเรียน</b></span></div>
                                <div>
                                    <span style={{ paddingLeft: '2em' }}><b>กิจกรรมที่เคยเข้าร่วมกับมูลนิธิแม่ฟ้าหลวงฯ:</b></span>{' '}{data.doitung_activities}
                                </div>
                                <div>
                                    <span style={{ paddingLeft: '2em' }}><b>กิจกรรมที่เข้าร่วมกับโรงเรียน:</b></span>{' '}{data.school_activities}
                                </div>
                                <div>
                                    <span style={{ paddingLeft: '2em' }}><b>กิจกรรมอื่นๆ:</b></span>{' '}{data.other_activities}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </div>
            })

            await this.promisedSetState({ loading: false })

        } else if (mode === 'read' && report === 'long') {

            await this.promisedSetState({ loading: true })

            const responseApplicant = await axios.get(`${process.env.REACT_APP_API}/application/${this.props.params.id}`, this.state.authHeader);
            const data = responseApplicant.data[0]

            const monthNamesThai = [
                'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
                'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
            ];

            function formatDateThaiShort(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                if (isNaN(date)) return '';
                const day = date.getDate();
                const month = monthNamesThai[date.getMonth()];
                const year = (date.getFullYear() + 543) % 100;
                return `${day} ${month} ${year}`;
            }

            function formatDateThaiLong(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                if (isNaN(date)) return '';
                const day = date.getDate();
                const monthNamesThai = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
                const month = monthNamesThai[date.getMonth()];
                const year = (date.getFullYear() + 543) % 100;
                return { day, month, year };
            }

            function formatActDate(startDateStr, endDateStr) {
                const start = formatDateThaiLong(startDateStr);
                const end = formatDateThaiLong(endDateStr);
                if (!start || !end) return '';
                if (start.day === end.day && start.month === end.month && start.year === end.year)
                    return `${start.day} ${start.month} ${start.year}`;
                if (start.year === end.year && start.month === end.month)
                    return `${start.day} - ${end.day} ${start.month} ${start.year}`;
                if (start.year === end.year && start.month !== end.month)
                    return `${start.day} ${start.month} - ${end.day} ${end.month} ${start.year}`;
                return `${start.day} ${start.month} ${start.year} - ${end.day} ${end.month} ${end.year}`;
            }

            // ดึงข้อมูลการศึกษา
            try {
                const educationRes = await axios.get(
                    `${process.env.REACT_APP_API}/education/applicant/${data.applicant_id}`,
                    this.state.authHeader
                );
                const educationApiData = educationRes.data;
                await this.promisedSetState({
                    educationHistory: (Array.isArray(educationApiData) ? educationApiData : [educationApiData]).map(item => ({
                        year: item.start_year ? item.start_year.toString() : '',
                        level: item.year_level || '',
                        institution: item.school_name || '',
                        major: item.study_field || '',
                        gpax: item.gpax ? item.gpax.toString() : null
                    }))
                });
            } catch (error) {
                console.error('Error loading education:', error.response?.data || error.message);
                await this.promisedSetState({ educationHistory: [] });
            }

            // ดึงข้อมูลฝึกงาน
            try {
                const internRes = await axios.get(
                    `${process.env.REACT_APP_API}/internship/applicant/${data.applicant_id}`,
                    this.state.authHeader
                );
                const internshipApiData = internRes.data;
                const internshipHistory = (Array.isArray(internshipApiData) ? internshipApiData : [internshipApiData]).map(item => ({
                    id: item.id,
                    internStartDate: formatDateThaiShort(item.intern_start_date) || '',
                    internEndDate: formatDateThaiShort(item.intern_end_date) || '',
                    position: item.intern_position || '',
                    company: item.intern_company || ''
                }));
                await this.promisedSetState({ internshipHistory });
            } catch (error) {
                console.error('Error loading internship:', error.response?.data || error.message);
                await this.promisedSetState({ internshipHistory: [] });
            }

            // ดึงข้อมูลกิจกรรม
            try {
                const activityRes = await axios.post(
                    `${process.env.REACT_APP_API}/activity/applicant`,
                    {
                        applicants_id: data.applicant_id,
                        search_type: '',
                        search_date: '',
                        search_text: '',
                    },
                    this.state.authHeader
                );
                const activityApiData = activityRes.data;
                const activityHistory = (Array.isArray(activityApiData) ? activityApiData : [activityApiData]).map(item => ({
                    id: item.id,
                    actType: item.act_type || "",
                    actName: item.act_name || "",
                    actPlace: item.act_place || "",
                    actDate: formatActDate(item.act_start, item.act_end) || ""
                }));
                await this.promisedSetState({ activityHistory });
            } catch (error) {
                console.error('Error loading activity:', error.response?.data || error.message);
                await this.promisedSetState({ activityHistory: [] });
            }

            // ดึงข้อมูลการทำงาน
            try {
                const careerRes = await axios.get(
                    `${process.env.REACT_APP_API}/career/applicant/${data.applicant_id}`,
                    this.state.authHeader
                );
                const careerApiData = careerRes.data;
                const careerHistory = (Array.isArray(careerApiData) ? careerApiData : [careerApiData]).map(item => ({
                    id: item.id,
                    start_date: formatDateThaiShort(item.start_date) || "-",
                    end_date: formatDateThaiShort(item.end_date) || "-",
                    department: item.department || "-",
                    company_name: item.company_name || "-",
                }));
                await this.promisedSetState({ careerHistory });
            } catch (error) {
                console.error('Error loading career:', error.response?.data || error.message);
                await this.promisedSetState({ careerHistory: [] });
            }

            // ดึงข้อมูลการขอคำปรึกษา
            try {
                const consultingRes = await axios.get(
                    `${process.env.REACT_APP_API}/recommendations/by-application/${data.applicant_id}`,
                    this.state.authHeader
                );
                const consultingApiData = consultingRes.data;
                const consultingHistory = (Array.isArray(consultingApiData) ? consultingApiData : [consultingApiData]).map(item => ({
                    id: item.id,
                    consult_date: formatDateThaiShort(item.date) || '-',
                    counselor_name: item.consultant || '-',
                    follow_up_plan: item.follow_up || '-',
                    record_date: formatDateThaiShort(item.createdAt) || '-',
                }));
                await this.promisedSetState({ consultingHistory });
            } catch (error) {
                console.error('Error loading consulting:', error.response?.data || error.message);
                await this.promisedSetState({ consultingHistory: [] });
            }

            // Styles
            const cellStyle = {
                border: '0.5px solid #ccc',
                padding: '4px',
                fontWeight: 'normal',
                textAlign: 'center'
            };

            const cellStyleLeft = {
                ...cellStyle,
                textAlign: 'left'
            };

            const headerStyle = {
                ...cellStyle,
                backgroundColor: '#f0f0f0',
                fontWeight: 'bold'
            };

            const statusMap = {
                'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ': data.parent_status_1,
                'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ': data.parent_status_2,
                'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ': data.parent_status_3,
                'อื่นๆ โปรดระบุ': data.parent_status_4
            };

            const extraText = statusMap[data.parent_status] || '';

            const parentStatusText = extraText
                ? `${data.parent_status} ${extraText}`
                : data.parent_status;

            await this.promisedSetState({
                content: <div><Row>
                    <Col>
                        <Card id="printable" border="light"
                            className='shadow-sm'
                            style={{
                                paddingLeft: "1.5em",
                                paddingTop: "1em",
                                paddingRight: "1em",
                                paddingBottom: "1em",
                                fontSize: '16pt',
                                lineHeight: '1.2'
                            }}>

                            <div>
                                <Image
                                    src={`${process.env.REACT_APP_UPLOAD}/${data.path}`}
                                    rounded
                                    style={{ width: '2.5cm', height: '3.5cm' }}
                                />
                            </div>

                            <div style={{ marginTop: '1em' }}><span><b>ข้อมูลทั่วไป</b></span></div>

                            <div style={{ marginBottom: '0.1em' }}><span>เลขบัตรประชาชน: </span><span>{data.id_card_number}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อ-สกุล: </span><span>{`${data.first_name} ${data.last_name}`}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อเล่น: </span><span>{data.nickname}</span></div>
                            <div style={{ marginBottom: '0.1em' }}>
                                <span>ชนเผ่า: </span>
                                <span>
                                    {data.ethnicity === 'อื่นๆ'
                                        ? (data.ethnicity_other || '-')
                                        : (data.ethnicity || '-')}
                                </span>
                            </div>
                            <div style={{ marginBottom: '0.1em' }}>
                                <span>วัน/เดือน/ปี เกิด: </span><span>{this.formatDateOfBirth(data.date_of_birth)}</span>
                                <span style={{ paddingLeft: '1em' }}>อายุ: </span><span>{this.calculateAge(data.date_of_birth)} ปี</span>
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่ตามทะเบียนบ้าน: </span><span>{
                                data.reg_province_id === 1
                                    ? (
                                        <>
                                            บ้านเลขที่ {data.reg_house_number}{' '}
                                            หมู่ที่ {data.reg_village_no}{' '}
                                            หมู่บ้าน {data.reg_village === 'other' ? data.reg_village_name : data.reg_village}{' '}
                                            {data.reg_tambon}{' '}
                                            {data.reg_amphur}{' '}
                                            {data.reg_province}{' '}
                                        </>
                                    )
                                    : (
                                        <>
                                            บ้านเลขที่ {data.reg_house_number}{' '}
                                            หมู่ที่ {data.reg_village_no}{' '}
                                            หมู่บ้าน {data.reg_village === 'other' ? data.reg_village_name : data.reg_village}{' '}
                                            ต.{data.reg_tambon}{' '}
                                            อ.{data.reg_amphur}{' '}
                                            จ.{data.reg_province}{' '}
                                        </>
                                    )
                            }</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่จริงในปัจจุบัน: </span><span>{data.is_reg_address === 'yes' ? 'ใช่' :
                                (
                                    <>
                                        บ้านเลขที่ {data.temp_house_number}{' '}
                                        หมู่ที่ {data.temp_village_no}{' '}
                                        หมู่บ้าน {data.temp_village === 'other' ? data.temp_village_name : data.temp_village}{' '}
                                        ต.{data.temp_tambon}{' '}
                                        อ.{data.temp_amphur}{' '}
                                        จ.{data.temp_province}{' '}
                                    </>
                                )}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>โทรศัพท์ติดต่อส่วนตัวของผู้สมัครขอรับทุน: </span><span>{data.phone}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว: </span>
                                {data.is_family_residence === 'yes' ? <span>มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว จำนวน {data.family_residence_rai} ไร่ {data.family_residence_ngan} งาน {data.family_residence_wah} ตารางวา</span>
                                    : <span>ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</span>}
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่ทำกินของครอบครัว: </span>
                                {data.is_family_work === 'yes' ? <span>มีที่ทำกินเป็นของครอบครัว จำนวน {data.family_work_rai} ไร่ {data.family_work_ngan} งาน {data.family_work_wah} ตารางวา</span>
                                    : <span>ไม่มีที่ทำกินของครอบครัว</span>}
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่: </span>
                                {data.is_none_residence === 'yes' ? <span>มีบ้าน/ที่อยู่อาศัยนอกพื้นที่ จำนวน {data.none_residence_rai} ไร่ {data.none_residence_ngan} งาน {data.none_residence_wah} ตารางวา</span>
                                    : <span>ไม่มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</span>}
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่ทำกินนอกพื้นที่: </span>
                                {data.is_none_work === 'yes' ? <span>มีที่ทำกินเป็นนอกพื้นที่ จำนวน {data.none_work_rai} ไร่ {data.none_work_ngan} งาน {data.none_work_wah} ตารางวา</span>
                                    : <span>ไม่มีที่ทำกินนอกพื้นที่</span>}
                            </div>

                            <div style={{ marginTop: '1em' }}>
                                <div style={{ marginBottom: '0.3em', fontWeight: 'bold' }}>
                                    <i className="bi bi-book-half"></i>{' '}ข้อมูลการศึกษา
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>ระดับการศึกษาที่ศึกษาอยู่: </span>
                                    <span>{data.edu_level}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สถานศึกษา ณ ปัจจุบัน: </span>
                                    <span>{data.curr_institution}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สาย/สาขาวิชา: </span>
                                    <span>{data.curr_field}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>ผลการเรียนเฉลี่ยรวม (5 ภาคเรียนหรือเทอมล่าสุด): </span>
                                    <span>{data.grades}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สถานศึกษาที่จะเรียนต่อ: </span>
                                    <span>{data.next_institution}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สาย/สาขาที่จะเรียนต่อ: </span>
                                    <span>{data.next_field}</span>
                                </div>

                                <div style={{ marginBottom: '0.5em' }}>
                                    <span>สถานะการสมัครเรียนในมหาวิทยาลัย: </span>
                                    <span>{data.app_status}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                    <span>ตารางประวัติการศึกษา</span>
                                </div>

                                <div style={{
                                    overflow: 'hidden',
                                    outline: '0.5px solid #ccc',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                    marginBottom: '0.5em'
                                }}>
                                    <table style={{
                                        width: '100%',
                                        borderCollapse: 'collapse'
                                    }}>
                                        <thead>
                                            <tr>
                                                <td style={headerStyle}>ปีการศึกษา</td>
                                                <td style={headerStyle}>ระดับการศึกษา</td>
                                                <td style={headerStyle}>ชื่อโรงเรียน/สถาบัน</td>
                                                <td style={headerStyle}>สาย/สาขาวิชาที่เรียน</td>
                                                <td style={headerStyle}>GPAX</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.educationHistory.length > 0 ? (
                                                this.state.educationHistory.map((item, index) => (
                                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                        <td style={cellStyle}>{item.year}</td>
                                                        <td style={cellStyle}>{item.level}</td>
                                                        <td style={cellStyleLeft}>{item.institution}</td>
                                                        <td style={cellStyleLeft}>{item.major}</td>
                                                        <td style={cellStyle}>{item.gpax}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                        ไม่มีข้อมูลประวัติการศึกษา
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>

                                <div style={{ marginTop: '1em' }}>
                                    <div style={{ marginBottom: '0.3em', fontWeight: 'bold' }}>
                                        <i className="bi bi-suitcase-lg-fill"></i>{' '}ข้อมูลการทำงาน
                                    </div>

                                    <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                        <span>ตารางประวัติการฝึกงาน</span>
                                    </div>

                                    <div style={{
                                        overflow: 'hidden',
                                        outline: '0.5px solid #ccc',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                        marginBottom: '0.5em',
                                    }}>
                                        <table style={{
                                            width: '100%',
                                            borderCollapse: 'collapse'
                                        }}>
                                            <thead>
                                                <tr>
                                                    <td style={headerStyle}>วันที่เริ่มงาน</td>
                                                    <td style={headerStyle}>วันที่สิ้นสุด</td>
                                                    <td style={headerStyle}>ตำแหน่ง</td>
                                                    <td style={headerStyle}>ชื่อบริษัทหรือหน่วยงาน</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.careerHistory && this.state.careerHistory.length > 0 ? (
                                                    this.state.careerHistory.map((item, index) => (
                                                        <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                            <td style={cellStyle}>{item.start_date}</td>
                                                            <td style={cellStyle}>{item.end_date}</td>
                                                            <td style={cellStyleLeft}>{item.department}</td>
                                                            <td style={cellStyleLeft}>{item.company_name}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                            ไม่มีข้อมูลประวัติการฝึกงาน
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                        <span>ตารางประวัติการทำงาน</span>
                                    </div>

                                    <div style={{
                                        overflow: 'hidden',
                                        outline: '0.5px solid #ccc',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
                                    }}>
                                        <table style={{
                                            width: '100%',
                                            borderCollapse: 'collapse'
                                        }}>
                                            <thead>
                                                <tr>
                                                    <td style={headerStyle}>วันที่เริ่มงาน</td>
                                                    <td style={headerStyle}>วันที่สิ้นสุด</td>
                                                    <td style={headerStyle}>ตำแหน่ง</td>
                                                    <td style={headerStyle}>ชื่อบริษัทหรือหน่วยงาน</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.internshipHistory && this.state.internshipHistory.length > 0 ? (
                                                    this.state.internshipHistory.map((item, index) => (
                                                        <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                            <td style={cellStyle}>{item.internStartDate}</td>
                                                            <td style={cellStyle}>{item.internEndDate}</td>
                                                            <td style={cellStyleLeft}>{item.position}</td>
                                                            <td style={cellStyleLeft}>{item.company}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                            ไม่มีข้อมูลประวัติการทำงาน
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '1em' }}><span><b><i className="bi bi-people-fill"></i> ข้อมูลครอบครัว</b></span></div>

                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อ - สกุล บิดา (ผู้ให้กำเนิด): </span><span>{data.father_full_name}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อายุบิดา: </span><span>{data.father_age} ปี</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อาชีพของบิดา: </span><span>{data.father_occupation}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>สถานที่ทำงานของบิดา: </span><span>{data.father_workplace}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>หมายเลขโทรศัพท์ของบิดา: </span><span>{data.father_phone}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อ-สกุล มารดา (ผู้ให้กำเนิด): </span><span>{data.mother_full_name}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อายุมารดา: </span><span>{data.mother_age} ปี</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อาชีพของมารดา: </span><span>{data.mother_occupation}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>สถานที่ทำงานของมารดา: </span><span>{data.mother_workplace}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>หมายเลขโทรศัพท์ของมารดา: </span><span>{data.mother_phone}</span></div>
                            <div style={{ marginBottom: '0.1em' }}>
                                <span>สถานะของบิดา มารดา: </span>
                                <span>{parentStatusText}</span>
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ผู้ปกครองที่สามารถติดต่อได้: {data.contactable} ความเกี่ยวข้องกับผู้สมัคร: {data.relationship_to_applicant}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องร่วมบิดามารดา: (ไม่รวมผู้สมัคร) {data.total_siblings} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่ทำงานแล้ว: {data.working_siblings} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่เรียน: {data.siblings_in_school} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่ว่างงาน: {data.unemployed_siblings} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน: {data.siblings_not_of_age} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>รายได้รวมต่อปีของครอบครัว (รวมรายได้ของบิดา/มารดา/พี่น้องที่ทำงานแล้ว): {this.formatBaht(data.family_income_per_year)} บาท/ปี</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span style={{ paddingLeft: '1em' }}>ชื่อ-สกุล: {data.provider_full_name}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span style={{ paddingLeft: '1em' }}>ความเกี่ยวข้องกับผู้สมัคร: {data.provider_relationship}</span></div>

                            <div style={{ marginTop: '1em' }}><span><b><i className="bi bi-palette-fill"></i> ข้อมูลด้านการเข้าร่วมกิจกรรม</b></span></div>

                            <div style={{ marginBottom: '0.1em' }}><span>กิจกรรมที่เคยเข้าร่วมของมูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์/โครงการพัฒนาดอยตุงฯ: {data.doitung_activities}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>กิจกรรมที่เคยเข้าร่วมของโรงเรียน: {data.school_activities}</span></div>
                            <div style={{ marginBottom: '0.5em' }}><span>กิจกรรมที่อื่นๆ ที่เคยเข้าร่วม: {data.other_activities}</span></div>

                            <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                <span>ตารางข้อมูลประวัติการเข้าร่วมกิจกรรมระหว่างการศึกษา</span>
                            </div>

                            <div style={{
                                overflow: 'hidden',
                                outline: '0.5px solid #ccc',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
                            }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse'
                                }}>
                                    <thead>
                                        <tr>
                                            <td style={headerStyle}>วันที่กิจกรรม</td>
                                            <td style={headerStyle}>ประเภท</td>
                                            <td style={headerStyle}>ชื่อกิจกรรม</td>
                                            <td style={headerStyle}>สถานที่</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.activityHistory && this.state.activityHistory.length > 0 ? (
                                            this.state.activityHistory.map((item, index) => (
                                                <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                    <td style={cellStyle}>{item.actDate}</td>
                                                    <td style={cellStyle}>{item.actType}</td>
                                                    <td style={cellStyleLeft}>{item.actName}</td>
                                                    <td style={cellStyleLeft}>{item.actPlace}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                    ไม่มีข้อมูลประวัติการเข้าร่วมกิจกรรม
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div style={{ marginTop: '1em' }}><span><b>ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์</b></span></div>

                            {data.rights1 && (<><div><span>สิทธิ์ที่ 1 </span><span>เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>- เลข คพต.พ ของผู้สมัคร: </span><span>{data.applicant_proj_no}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>- เลข คพต.พ ของบิดา: </span><span>{data.father_proj_no}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>- เลข คพต.พ ของมารดา: </span><span>{data.mother_proj_no}</span></div></>)}
                            {data.rights2 && (<><div><span>สิทธิ์ที่ 2 </span><span>เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการขยายผลของมูลนิธิแม่ฟ้าหลวง พระบรมราชูปถัมภ์</span></div></>)}
                            {data.rights3 && (<><div><span>สิทธิ์ที่ 3 </span><span>เป็นเยาวชนที่กำลังศึกษาระดับชั้นมัธยมศึกษาปีที่ 6 ในโรงเรียนบ้านห้วยไร่สามัคคี</span></div></>)}
                            {data.rights4 && (<><div><span>สิทธิ์ที่ 4 </span><span>เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน)</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>รายละเอียดบุคคลที่ทำงานในมูลนิธิแม่ฟ้าหลวงฯ</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}>
                                    <span>
                                        บิดา รหัสพนักงาน: {data.rights_father_no || '-'}
                                        {' '}ตำแหน่งงาน: {data.rights_father_job_title || '-'}
                                    </span>
                                </div>

                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}>
                                    <span>
                                        ส่วนงาน/แผนก: {data.rights_father_department || '-'}
                                        {' '}จำนวนปีที่ทำงานในมูลนิธิฯ: {data.rights_father_years || '-'} ปี
                                    </span>
                                </div>

                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}>
                                    <span>
                                        มารดา รหัสพนักงาน: {data.rights_mother_no || '-'}
                                        {' '}ตำแหน่งงาน: {data.rights_mother_job_title || '-'}
                                    </span>
                                </div>

                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}>
                                    <span>
                                        ส่วนงาน/แผนก: {data.rights_mother_department || '-'}
                                        {' '}จำนวนปีที่ทำงานในมูลนิธิฯ: {data.rights_mother_years || '-'} ปี
                                    </span>
                                </div></>)}

                            <div style={{ marginTop: '1em' }}>
                                <div style={{ marginBottom: '0.3em', fontWeight: 'bold' }}>
                                    <i className="bi bi-chat-dots-fill"></i>{' '}การขอคำปรึกษา
                                </div>

                                <div style={{
                                    overflow: 'hidden',
                                    outline: '0.5px solid #ccc',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                    marginBottom: '0.5em'
                                }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <td style={headerStyle}>ลำดับ</td>
                                                <td style={headerStyle}>วันที่ให้คำปรึกษา</td>
                                                <td style={headerStyle}>ชื่อผู้ให้คำปรึกษา</td>
                                                <td style={headerStyle}>แผนการติดตาม</td>
                                                <td style={headerStyle}>วันที่บันทึก</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.consultingHistory && this.state.consultingHistory.length > 0 ? (
                                                this.state.consultingHistory.map((item, index) => (
                                                    <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                        <td style={cellStyle}>{index + 1}</td>
                                                        <td style={cellStyle}>{item.consult_date}</td>
                                                        <td style={cellStyleLeft}>{item.counselor_name}</td>
                                                        <td style={cellStyleLeft}>{item.follow_up_plan}</td>
                                                        <td style={cellStyle}>{item.record_date}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                        ไม่มีข้อมูลการขอคำปรึกษา
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
                    <br />
                </div>
            })

            await this.promisedSetState({ loading: false })
        }
    }

    generateRandomString = (amount) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < amount; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    handlePrint = () => {
        // Open a new window with full screen size (height and width of the current browser window)
        const printWindow = window.open('', '', `height=${window.innerHeight},width=${window.innerWidth}`);

        const content = document.getElementById('printable').innerHTML; // Get content to print by ID

        // Define the print styles and include the font-face rule
        const printStyles = `
            @font-face {
                font-family: 'TH_Sarabun';
                src: url(${TH_Sarabun_PSK});
            }
            body {
                font-family: 'TH_Sarabun', sans-serif;
                font-size: 14pt;
                line-height: 1.2;
            }
            /* Additional styles for printing */
        `;

        const randomString = this.generateRandomString(8); // Generate a random 8-character string

        // Write the content into the new window
        printWindow.document.write(`<html><head><title>${randomString}</title>`);
        printWindow.document.write(`<style>${printStyles}</style>`);  // Add styles to the print window
        printWindow.document.write('</head><body>');
        printWindow.document.write(content); // Add the content to print
        printWindow.document.write('</body></html>');

        // Close the document and trigger the print dialog after a delay
        printWindow.document.close();

        // Add delay for the content to load properly
        setTimeout(() => {
            printWindow.print();
        }, 500); // Adjust time if necessary
    };

    handleExportToDocx = async () => {
        const data = this.state.data;
        if (!data) { console.error("No data available"); return; }

        const FONT = "TH Sarabun New";
        const FONT_SIZE = 32;
        const LINE_SPACING = { line: 240, lineRule: "auto" };
        const TAB = "\t";

        const run = (text, opts = {}) =>
            new TextRun({ text: String(text ?? ""), font: FONT, size: FONT_SIZE, language: { value: "th-TH" }, ...opts });

        const para = (children, opts = {}) =>
            new Paragraph({ children: Array.isArray(children) ? children : [children], spacing: { ...LINE_SPACING, before: 0, after: 0 }, ...opts });

        const paraSection = (children, opts = {}) =>
            new Paragraph({ children: Array.isArray(children) ? children : [children], spacing: { ...LINE_SPACING, before: 160, after: 0 }, ...opts });

        const labelVal = (label, value) => [
            run(label, { bold: true }), run(" "), run(String(value ?? "")), run("   "),
        ];

        const labelValTab = (label, value, tabs = 1) => [
            run(TAB.repeat(tabs)), run(label, { bold: true }), run(" "), run(String(value ?? "")), run("   "),
        ];

        const cb = (checked, label) => run(`${checked ? "☑" : "☐"} ${label}   `);

        const statusMap = {
            'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ': data.parent_status_1,
            'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ': data.parent_status_2,
            'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ': data.parent_status_3,
            'อื่นๆ โปรดระบุ': data.parent_status_4,
        };
        const extraText = statusMap[data.parent_status] || '';
        const parentStatusText = extraText ? `${data.parent_status} ${extraText}` : data.parent_status;

        // ---- fetch image ----
        let imageData = null;
        let imageType = "jpg";
        try {
            const resp = await fetch(`${process.env.REACT_APP_UPLOAD}/${data.path}`);
            const blob = await resp.blob();
            imageType = blob.type.includes("png") ? "png" : "jpg";
            imageData = await new Promise((res) => {
                const r = new FileReader();
                r.onloadend = () => res(r.result);
                r.readAsArrayBuffer(blob);
            });
        } catch (e) { console.error("Image fetch error:", e); }

        const addressText = data.reg_province_id === 1
            ? `บ้านเลขที่ ${data.reg_house_number} หมู่ที่ ${data.reg_village_no} หมู่บ้าน${data.reg_village === "other" ? data.reg_village_name : data.reg_village} ${data.reg_tambon} ${data.reg_amphur} ${data.reg_province}`
            : `บ้านเลขที่ ${data.reg_house_number} หมู่ที่ ${data.reg_village_no} หมู่บ้าน${data.reg_village === "other" ? data.reg_village_name : data.reg_village} ต.${data.reg_tambon} อ.${data.reg_amphur} จ.${data.reg_province}`;

        const applicantProjNo = !data.applicant_proj_no || data.applicant_proj_no === "คพต.พ _-__-____" ? "-" : data.applicant_proj_no;
        const fatherEmpNo = data.rights4 ? data.rights_father_no || "-" : "-";
        const fatherDept = data.rights4 ? data.rights_father_job_title || "-" : "-";
        const motherEmpNo = data.rights4 ? data.rights_mother_no || "-" : "-";
        const motherDept = data.rights4 ? data.rights_mother_job_title || "-" : "-";

        const children = [];

        // ---- Photo ----
        if (imageData) {
            children.push(new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: { after: 20 },
                children: [new ImageRun({
                    data: imageData, type: imageType,
                    transformation: { width: convertMillimetersToTwip(15 / 10), height: convertMillimetersToTwip(20 / 10) },
                })],
            }));
        }

        // ===== ประวัติย่อ (short) =====
        const currentReport = this.state.currentReport || 'short';

        if (currentReport === 'short') {

            children.push(para([
                run("สิทธิ์ในการสมัคร  ", { bold: true }),
                cb(data.rights4, "บุตรพนักงาน"),
                cb(data.rights1, "พื้นที่โครงการพัฒนาดอยตุงฯ"),
                cb(data.rights2, "พื้นที่ขยายผลในมูลนิธิฯ"),
                cb(data.rights3, "โรงเรียนบ้านห้วยไร่สามัคคี"),
            ]));

            children.push(paraSection([run("ข้อมูลทั่วไป", { bold: true, underline: {} })]));
            children.push(para([...labelVal("ชื่อ-สกุล:", `${data.first_name} ${data.last_name}`), ...labelValTab("ชื่อเล่น:", data.nickname, 2)]));
            children.push(para([...labelVal("วัน/เดือน/ปี เกิด:", this.formatDateOfBirth(data.date_of_birth)), ...labelValTab("อายุ:", `${this.calculateAge(data.date_of_birth)} ปี`, 2), ...labelValTab("เบอร์โทร:", data.phone, 1)]));
            children.push(para([run("ที่อยู่:", { bold: true }), run("  "), run(addressText)]));
            children.push(para([...labelVal("เลขบัตรประชาชน:", data.id_card_number), ...labelValTab("เลข คพต.พ ของผู้สมัคร:", applicantProjNo, 1)]));
            children.push(para([...labelVal("การศึกษาเดิม:", data.edu_level), ...labelValTab("โรงเรียน:", data.curr_institution, 2)]));
            children.push(para([...labelValTab("สายการเรียน:", data.curr_field, 6)]));
            children.push(para([...labelVal("ผลการเรียน:", data.grades)]));

            children.push(paraSection([run("ข้อมูลการศึกษาต่อ", { bold: true, underline: {} })]));
            children.push(para([...labelVal("สถานศึกษา:", data.next_institution)]));
            children.push(para([...labelVal("สาขาที่ศึกษาต่อ:", data.next_field)]));

            children.push(paraSection([run("ข้อมูลการพิจารณาทุน", { bold: true, underline: {} })]));
            children.push(para([run("ส่วนที่ 1 ครอบครัวและรายได้", { bold: true })]));
            children.push(para([...labelVal("สภาพครอบครัว:", parentStatusText)]));
            children.push(para([run("    "), ...labelVal("ชื่อบิดา:", data.father_full_name), ...labelValTab("อาชีพ:", data.father_occupation, 2), ...labelVal("รหัสพนักงาน:", fatherEmpNo)]));
            children.push(para([run("    "), ...labelValTab("ส่วนงาน/แผนก:", fatherDept, 6)]));
            children.push(para([run("    "), ...labelVal("ชื่อมารดา:", data.mother_full_name), ...labelValTab("อาชีพ:", data.mother_occupation, 2), ...labelVal("รหัสพนักงาน:", motherEmpNo)]));
            children.push(para([run("    "), ...labelValTab("ส่วนงาน/แผนก:", motherDept, 6)]));
            children.push(para([run("    "), ...labelVal("จำนวนพี่น้อง:", `${data.total_siblings} คน`)]));
            children.push(para([...labelVal("จำนวนรายได้รวม:", `${this.formatBaht(data.family_income_per_year)} บาท ต่อปี`)]));
            children.push(para([...labelVal("ที่อยู่อาศัยในพื้นที่:", `${data.family_residence_rai} ไร่ ${data.family_residence_ngan} งาน ${data.family_residence_wah} ตารางวา`)]));
            children.push(para([...labelVal("ที่ทำกินในพื้นที่:", `${data.family_work_rai} ไร่ ${data.family_work_ngan} งาน ${data.family_work_wah} ตารางวา`)]));
            children.push(para([...labelVal("ที่อยู่อาศัยนอกพื้นที่:", "- ไร่ - งาน - ตารางวา")]));
            children.push(para([...labelVal("ที่ทำกินนอกพื้นที่:", "- ไร่ - งาน - ตารางวา")]));

            children.push(paraSection([run("ส่วนที่ 2 กิจกรรมที่เข้าร่วมระหว่างเรียน", { bold: true })]));
            children.push(para([run("    "), run("กิจกรรมที่เคยเข้าร่วมกับมูลนิธิแม่ฟ้าหลวงฯ: ", { bold: true }), run(data.doitung_activities)]));
            children.push(para([run("    "), run("กิจกรรมที่เข้าร่วมกับโรงเรียน: ", { bold: true }), run(data.school_activities)]));
            children.push(para([run("    "), run("กิจกรรมอื่นๆ: ", { bold: true }), run(data.other_activities)]));

        } else {
            // ===== ประวัติแบบละเอียด (long) =====

            children.push(paraSection([run("ข้อมูลทั่วไป", { bold: true })]));
            children.push(para([...labelVal("เลขบัตรประชาชน:", data.id_card_number)]));
            children.push(para([...labelVal("ชื่อ-สกุล:", `${data.first_name} ${data.last_name}`)]));
            children.push(para([...labelVal("ชื่อเล่น:", data.nickname)]));
            children.push(para([...labelVal("ชนเผ่า:", data.ethnicity === 'อื่นๆ' ? (data.ethnicity_other || '-') : (data.ethnicity || '-'))]));
            children.push(para([...labelVal("วัน/เดือน/ปี เกิด:", this.formatDateOfBirth(data.date_of_birth)), ...labelValTab("อายุ:", `${this.calculateAge(data.date_of_birth)} ปี`, 1)]));
            children.push(para([...labelVal("ที่อยู่ตามทะเบียนบ้าน:", addressText)]));

            const currentAddress = data.is_reg_address === 'yes' ? 'เหมือนที่อยู่ตามทะเบียนบ้าน' :
                `บ้านเลขที่ ${data.temp_house_number} หมู่ที่ ${data.temp_village_no} หมู่บ้าน${data.temp_village === 'other' ? data.temp_village_name : data.temp_village} ต.${data.temp_tambon} อ.${data.temp_amphur} จ.${data.temp_province}`;
            children.push(para([...labelVal("ที่อยู่จริงในปัจจุบัน:", currentAddress)]));
            children.push(para([...labelVal("โทรศัพท์:", data.phone)]));

            const residenceText = data.is_family_residence === 'yes'
                ? `มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว จำนวน ${data.family_residence_rai} ไร่ ${data.family_residence_ngan} งาน ${data.family_residence_wah} ตารางวา`
                : 'ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว';
            const workText = data.is_family_work === 'yes'
                ? `มีที่ทำกินเป็นของครอบครัว จำนวน ${data.family_work_rai} ไร่ ${data.family_work_ngan} งาน ${data.family_work_wah} ตารางวา`
                : 'ไม่มีที่ทำกินของครอบครัว';
            const noneResidenceText = data.is_none_residence === 'yes'
                ? `มีบ้าน/ที่อยู่อาศัยนอกพื้นที่ จำนวน ${data.none_residence_rai} ไร่ ${data.none_residence_ngan} งาน ${data.none_residence_wah} ตารางวา`
                : 'ไม่มีบ้าน/ที่อยู่อาศัยนอกพื้นที่';
            const noneWorkText = data.is_none_work === 'yes'
                ? `มีที่ทำกินนอกพื้นที่ จำนวน ${data.none_work_rai} ไร่ ${data.none_work_ngan} งาน ${data.none_work_wah} ตารางวา`
                : 'ไม่มีที่ทำกินนอกพื้นที่';
            children.push(para([...labelVal("ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว:", residenceText)]));
            children.push(para([...labelVal("ที่ทำกินของครอบครัว:", workText)]));
            children.push(para([...labelVal("ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่:", noneResidenceText)]));
            children.push(para([...labelVal("ที่ทำกินนอกพื้นที่:", noneWorkText)]));

            // ข้อมูลการศึกษา
            children.push(paraSection([run("ข้อมูลการศึกษา", { bold: true })]));
            children.push(para([...labelVal("ระดับการศึกษาที่ศึกษาอยู่:", data.edu_level)]));
            children.push(para([...labelVal("สถานศึกษา ณ ปัจจุบัน:", data.curr_institution)]));
            children.push(para([...labelVal("สาย/สาขาวิชา:", data.curr_field)]));
            children.push(para([...labelVal("ผลการเรียนเฉลี่ยรวม (5 ภาคเรียนหรือเทอมล่าสุด):", data.grades)]));
            children.push(para([...labelVal("สถานศึกษาที่จะเรียนต่อ:", data.next_institution)]));
            children.push(para([...labelVal("สาย/สาขาที่จะเรียนต่อ:", data.next_field)]));
            children.push(para([...labelVal("สถานะการสมัครเรียนในมหาวิทยาลัย:", data.app_status)]));

            // ตารางประวัติการศึกษา
            children.push(paraSection([run("ตารางประวัติการศึกษา", { bold: true })]));
            const eduHistory = this.state.educationHistory || [];
            if (eduHistory.length > 0) {
                const { Table, TableRow, TableCell, WidthType, BorderStyle, ShadingType, VerticalAlign } = await import("docx");
                const border = { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" };
                const borders = { top: border, bottom: border, left: border, right: border };
                const colWidths = [1200, 1800, 2800, 2400, 800]; // รวม = 9000 DXA
                const headerRow = new TableRow({
                    children: ["ปีการศึกษา", "ระดับการศึกษา", "ชื่อโรงเรียน/สถาบัน", "สาย/สาขาวิชา", "GPAX"].map((h, i) =>
                        new TableCell({
                            borders, width: { size: colWidths[i], type: WidthType.DXA },
                            shading: { fill: "F0F0F0", type: ShadingType.CLEAR },
                            margins: { top: 60, bottom: 60, left: 100, right: 100 },
                            children: [new Paragraph({ children: [run(h, { bold: true })] })]
                        })
                    )
                });
                const dataRows = eduHistory.map(item =>
                    new TableRow({
                        children: [item.year, item.level, item.institution, item.major, item.gpax || '-'].map((v, i) =>
                            new TableCell({
                                borders, width: { size: colWidths[i], type: WidthType.DXA },
                                margins: { top: 60, bottom: 60, left: 100, right: 100 },
                                children: [new Paragraph({ children: [run(v || '')] })]
                            })
                        )
                    })
                );
                children.push(new Table({ width: { size: 9000, type: WidthType.DXA }, columnWidths: colWidths, rows: [headerRow, ...dataRows] }));
            } else {
                children.push(para([run("ไม่มีข้อมูลประวัติการศึกษา")]));
            }

            // ข้อมูลการทำงาน
            children.push(paraSection([run("ข้อมูลการทำงาน", { bold: true })]));

            // ตารางประวัติการฝึกงาน
            children.push(para([run("ตารางประวัติการฝึกงาน", { bold: true })]));
            const careerHistory = this.state.careerHistory || [];
            if (careerHistory.length > 0) {
                const { Table, TableRow, TableCell, WidthType, BorderStyle, ShadingType } = await import("docx");
                const border = { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" };
                const borders = { top: border, bottom: border, left: border, right: border };
                const colWidths = [1800, 1800, 2700, 2700];
                const headerRow = new TableRow({
                    children: ["วันที่เริ่มงาน", "วันที่สิ้นสุด", "ตำแหน่ง", "ชื่อบริษัทหรือหน่วยงาน"].map((h, i) =>
                        new TableCell({
                            borders, width: { size: colWidths[i], type: WidthType.DXA },
                            shading: { fill: "F0F0F0", type: ShadingType.CLEAR },
                            margins: { top: 60, bottom: 60, left: 100, right: 100 },
                            children: [new Paragraph({ children: [run(h, { bold: true })] })]
                        })
                    )
                });
                const dataRows = careerHistory.map(item =>
                    new TableRow({
                        children: [item.start_date, item.end_date, item.department, item.company_name].map((v, i) =>
                            new TableCell({
                                borders, width: { size: colWidths[i], type: WidthType.DXA },
                                margins: { top: 60, bottom: 60, left: 100, right: 100 },
                                children: [new Paragraph({ children: [run(v || '')] })]
                            })
                        )
                    })
                );
                children.push(new Table({ width: { size: 9000, type: WidthType.DXA }, columnWidths: colWidths, rows: [headerRow, ...dataRows] }));
            } else {
                children.push(para([run("ไม่มีข้อมูลประวัติการฝึกงาน")]));
            }

            // ตารางประวัติการทำงาน
            children.push(paraSection([run("ตารางประวัติการทำงาน", { bold: true })]));
            const internshipHistory = this.state.internshipHistory || [];
            if (internshipHistory.length > 0) {
                const { Table, TableRow, TableCell, WidthType, BorderStyle, ShadingType } = await import("docx");
                const border = { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" };
                const borders = { top: border, bottom: border, left: border, right: border };
                const colWidths = [1800, 1800, 2700, 2700];
                const headerRow = new TableRow({
                    children: ["วันที่เริ่มงาน", "วันที่สิ้นสุด", "ตำแหน่ง", "ชื่อบริษัทหรือหน่วยงาน"].map((h, i) =>
                        new TableCell({
                            borders, width: { size: colWidths[i], type: WidthType.DXA },
                            shading: { fill: "F0F0F0", type: ShadingType.CLEAR },
                            margins: { top: 60, bottom: 60, left: 100, right: 100 },
                            children: [new Paragraph({ children: [run(h, { bold: true })] })]
                        })
                    )
                });
                const dataRows = internshipHistory.map(item =>
                    new TableRow({
                        children: [item.internStartDate, item.internEndDate, item.position, item.company].map((v, i) =>
                            new TableCell({
                                borders, width: { size: colWidths[i], type: WidthType.DXA },
                                margins: { top: 60, bottom: 60, left: 100, right: 100 },
                                children: [new Paragraph({ children: [run(v || '')] })]
                            })
                        )
                    })
                );
                children.push(new Table({ width: { size: 9000, type: WidthType.DXA }, columnWidths: colWidths, rows: [headerRow, ...dataRows] }));
            } else {
                children.push(para([run("ไม่มีข้อมูลประวัติการทำงาน")]));
            }

            // ข้อมูลครอบครัว
            children.push(paraSection([run("ข้อมูลครอบครัว", { bold: true })]));
            children.push(para([...labelVal("ชื่อ-สกุล บิดา (ผู้ให้กำเนิด):", data.father_full_name)]));
            children.push(para([...labelVal("อายุบิดา:", `${data.father_age} ปี`)]));
            children.push(para([...labelVal("อาชีพของบิดา:", data.father_occupation)]));
            children.push(para([...labelVal("สถานที่ทำงานของบิดา:", data.father_workplace)]));
            children.push(para([...labelVal("หมายเลขโทรศัพท์ของบิดา:", data.father_phone)]));
            children.push(para([...labelVal("ชื่อ-สกุล มารดา (ผู้ให้กำเนิด):", data.mother_full_name)]));
            children.push(para([...labelVal("อายุมารดา:", `${data.mother_age} ปี`)]));
            children.push(para([...labelVal("อาชีพของมารดา:", data.mother_occupation)]));
            children.push(para([...labelVal("สถานที่ทำงานของมารดา:", data.mother_workplace)]));
            children.push(para([...labelVal("หมายเลขโทรศัพท์ของมารดา:", data.mother_phone)]));
            children.push(para([...labelVal("สถานะของบิดา มารดา:", parentStatusText)]));
            children.push(para([...labelVal("ผู้ปกครองที่สามารถติดต่อได้:", data.contactable), ...labelValTab("ความเกี่ยวข้องกับผู้สมัคร:", data.relationship_to_applicant, 1)]));
            children.push(para([...labelVal("จำนวนพี่น้องร่วมบิดามารดา (ไม่รวมผู้สมัคร):", `${data.total_siblings} คน`)]));
            children.push(para([...labelVal("จำนวนพี่น้องที่ทำงานแล้ว:", `${data.working_siblings} คน`)]));
            children.push(para([...labelVal("จำนวนพี่น้องที่เรียน:", `${data.siblings_in_school} คน`)]));
            children.push(para([...labelVal("จำนวนพี่น้องที่ว่างงาน:", `${data.unemployed_siblings} คน`)]));
            children.push(para([...labelVal("จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน:", `${data.siblings_not_of_age} คน`)]));
            children.push(para([...labelVal("รายได้รวมต่อปีของครอบครัว:", `${this.formatBaht(data.family_income_per_year)} บาท/ปี`)]));
            children.push(para([run("ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร", { bold: true })]));
            children.push(para([run(TAB), ...labelVal("ชื่อ-สกุล:", data.provider_full_name)]));
            children.push(para([run(TAB), ...labelVal("ความเกี่ยวข้องกับผู้สมัคร:", data.provider_relationship)]));

            // ข้อมูลด้านการเข้าร่วมกิจกรรม
            children.push(paraSection([run("ข้อมูลด้านการเข้าร่วมกิจกรรม", { bold: true })]));
            children.push(para([...labelVal("กิจกรรมที่เคยเข้าร่วมของมูลนิธิแม่ฟ้าหลวงฯ:", data.doitung_activities)]));
            children.push(para([...labelVal("กิจกรรมที่เคยเข้าร่วมของโรงเรียน:", data.school_activities)]));
            children.push(para([...labelVal("กิจกรรมอื่นๆ ที่เคยเข้าร่วม:", data.other_activities)]));

            // ตารางกิจกรรม
            children.push(paraSection([run("ตารางข้อมูลประวัติการเข้าร่วมกิจกรรมระหว่างการศึกษา", { bold: true })]));
            const activityHistory = this.state.activityHistory || [];
            if (activityHistory.length > 0) {
                const { Table, TableRow, TableCell, WidthType, BorderStyle, ShadingType } = await import("docx");
                const border = { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" };
                const borders = { top: border, bottom: border, left: border, right: border };
                const colWidths = [2000, 1800, 3000, 2200];
                const headerRow = new TableRow({
                    children: ["วันที่กิจกรรม", "ประเภท", "ชื่อกิจกรรม", "สถานที่"].map((h, i) =>
                        new TableCell({
                            borders, width: { size: colWidths[i], type: WidthType.DXA },
                            shading: { fill: "F0F0F0", type: ShadingType.CLEAR },
                            margins: { top: 60, bottom: 60, left: 100, right: 100 },
                            children: [new Paragraph({ children: [run(h, { bold: true })] })]
                        })
                    )
                });
                const dataRows = activityHistory.map(item =>
                    new TableRow({
                        children: [item.actDate, item.actType, item.actName, item.actPlace].map((v, i) =>
                            new TableCell({
                                borders, width: { size: colWidths[i], type: WidthType.DXA },
                                margins: { top: 60, bottom: 60, left: 100, right: 100 },
                                children: [new Paragraph({ children: [run(v || '')] })]
                            })
                        )
                    })
                );
                children.push(new Table({ width: { size: 9000, type: WidthType.DXA }, columnWidths: colWidths, rows: [headerRow, ...dataRows] }));
            } else {
                children.push(para([run("ไม่มีข้อมูลประวัติการเข้าร่วมกิจกรรม")]));
            }

            // ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์
            children.push(paraSection([run("ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์", { bold: true })]));
            if (data.rights1) {
                children.push(para([run("สิทธิ์ที่ 1 "), run("เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ")]));
                children.push(para([run(TAB), ...labelVal("- เลข คพต.พ ของผู้สมัคร:", data.applicant_proj_no)]));
                children.push(para([run(TAB), ...labelVal("- เลข คพต.พ ของบิดา:", data.father_proj_no)]));
                children.push(para([run(TAB), ...labelVal("- เลข คพต.พ ของมารดา:", data.mother_proj_no)]));
            }
            if (data.rights2) children.push(para([run("สิทธิ์ที่ 2 "), run("เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการขยายผลของมูลนิธิแม่ฟ้าหลวงฯ")]));
            if (data.rights3) children.push(para([run("สิทธิ์ที่ 3 "), run("เป็นเยาวชนที่กำลังศึกษาระดับชั้นมัธยมศึกษาปีที่ 6 ในโรงเรียนบ้านห้วยไร่สามัคคี")]));
            if (data.rights4) {
                children.push(para([run("สิทธิ์ที่ 4 "), run("เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน)")]));
                children.push(para([run(TAB), run("รายละเอียดบุคคลที่ทำงานในมูลนิธิแม่ฟ้าหลวงฯ")]));
                children.push(para([run(TAB), ...labelVal("บิดา รหัสพนักงาน:", data.rights_father_no || '-'), ...labelValTab("ตำแหน่งงาน:", data.rights_father_job_title || '-', 1)]));
                children.push(para([run(TAB), ...labelVal("ส่วนงาน/แผนก:", data.rights_father_department || '-'), ...labelValTab("จำนวนปีที่ทำงานในมูลนิธิฯ:", `${data.rights_father_years || '-'} ปี`, 1)]));
                children.push(para([run(TAB), ...labelVal("มารดา รหัสพนักงาน:", data.rights_mother_no || '-'), ...labelValTab("ตำแหน่งงาน:", data.rights_mother_job_title || '-', 1)]));
                children.push(para([run(TAB), ...labelVal("ส่วนงาน/แผนก:", data.rights_mother_department || '-'), ...labelValTab("จำนวนปีที่ทำงานในมูลนิธิฯ:", `${data.rights_mother_years || '-'} ปี`, 1)]));
            }

            // การขอคำปรึกษา
            children.push(paraSection([run("การขอคำปรึกษา", { bold: true })]));
            const consultingHistory = this.state.consultingHistory || [];
            if (consultingHistory.length > 0) {
                const { Table, TableRow, TableCell, WidthType, BorderStyle, ShadingType } = await import("docx");
                const border = { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" };
                const borders = { top: border, bottom: border, left: border, right: border };
                const colWidths = [600, 1600, 2200, 2800, 1800];
                const headerRow = new TableRow({
                    children: ["ลำดับ", "วันที่ให้คำปรึกษา", "ชื่อผู้ให้คำปรึกษา", "แผนการติดตาม", "วันที่บันทึก"].map((h, i) =>
                        new TableCell({
                            borders, width: { size: colWidths[i], type: WidthType.DXA },
                            shading: { fill: "F0F0F0", type: ShadingType.CLEAR },
                            margins: { top: 60, bottom: 60, left: 100, right: 100 },
                            children: [new Paragraph({ children: [run(h, { bold: true })] })]
                        })
                    )
                });
                const dataRows = consultingHistory.map((item, index) =>
                    new TableRow({
                        children: [`${index + 1}`, item.consult_date, item.counselor_name, item.follow_up_plan, item.record_date].map((v, i) =>
                            new TableCell({
                                borders, width: { size: colWidths[i], type: WidthType.DXA },
                                margins: { top: 60, bottom: 60, left: 100, right: 100 },
                                children: [new Paragraph({ children: [run(v || '')] })]
                            })
                        )
                    })
                );
                children.push(new Table({ width: { size: 9000, type: WidthType.DXA }, columnWidths: colWidths, rows: [headerRow, ...dataRows] }));
            } else {
                children.push(para([run("ไม่มีข้อมูลการขอคำปรึกษา")]));
            }
        }

        // ========== CREATE DOC ==========
        const doc = new Document({
            styles: {
                default: {
                    document: {
                        run: { font: FONT, size: FONT_SIZE, language: { value: "th-TH" } },
                        paragraph: { spacing: LINE_SPACING },
                    },
                },
            },
            sections: [{
                properties: {
                    page: {
                        size: { width: 11906, height: 16838 },
                        margin: { top: 1008, right: 1008, bottom: 1008, left: 1008 },
                    },
                },
                children,
            }],
        });

        const buffer = await Packer.toBlob(doc);
        const randomString = this.generateRandomString(8);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(buffer);
        link.download = `${randomString}.docx`;
        link.click();
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.header}
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(DetailPage);
